/* eslint-disable @typescript-eslint/naming-convention */

enum FEATURES {
  LIVE_CHAT_SUPPORT = 'live_chat_support',
  APPROVAL_FLOWS = 'approval_flows',
  SPENDING_POLICIES = 'spending_policies',
  PAYMENT_INBOX = 'payment_inbox', // TOREMOVE
  CUSTOM_FIELDS = 'custom_fields',
  CUSTOM_EXPORTS = 'custom_exports',
  ORGANISATION_BRANCHES = 'organisation_branches',
  TEAMS = 'teams',
  TEAM_MANAGER = 'team_manager',
  ERECEIPTS = 'ereceipts',
  PLASTIC_CARDS = 'plastic_cards',
  PHYSICAL_CARD_CONTROL_ADVANCED = 'physical_card_control_advanced',
  CARD_ORDER_EXPRESS_DELIVERY = 'card_order_express_delivery_flow',
  VIRTUAL_CARDS = 'virtual_cards',
  CARDS_ACCESS = 'cards_access',
  PLAY_BY_RULES = 'play_by_rules',
  PLAY_BY_RULES_MULTIPLE = 'play_by_rules_multiple',
  NETSUITE_ACCOUNTING_INTEGRATION = 'netsuite_accounting_integration',
  TMP_EEA_INTERNATIONAL_WIRE_TRANSFER = 'tmp_eea_international_wire_transfer',
  TMP_UK_INTERNATIONAL_WIRE_TRANSFER = 'tmp_uk_international_wire_transfer',
  HR_INTEGRATIONS = 'hr_integrations',
  // Technical features,
  WALLET_ACCESS = 'wallet_access',
  TMP_WALLET_WIRE_FUNDS_OUT = 'tmp_wallet_wire_funds_out',
  TMP_UK_WALLET_WIRE_FUNDS_OUT = 'tmp_uk_wallet_wire_funds_out',
  CASH_WITHDRAWAL = 'cash_withdrawal',
  SLACK_INTEGRATION = 'slack_integration',
  EXPENSE_CLAIMS = 'expense_claims',
  REIMBURSE_EXPENSES_VIA_SEPA = 'reimburse_expenses_via_sepa',
  MILEAGE_ALLOWANCES = 'mileage_allowances',
  PER_DIEM_ALLOWANCES = 'per_diem_allowances',
  SUBMIT_MY_INVOICE = 'submit_my_invoice',
  INVOICE_AUTO_APPROVED = 'invoice_auto_approved',
  AUTO_CAT = 'auto_cat',
  ML_AUTOMATION = 'ml_automation',
  WIRE_TRANSFER_FOR_EXPENSE_CLAIMS = 'wire_transfer_for_expense_claims',
  BUDGETS = 'budgets',
  BUDGETS_BY_DIMENSIONS = 'budgets_by_dimensions',
  BUDGETS_ADVANCED_DIMENSIONS = 'budgets_advanced_dimensions',
  BUDGETS_AI_CONFIG = 'budgets_ai_config',
  BILL_INBOX = 'bill_inbox',
  COST_CENTERS_ACTIVATED = 'cost_centers_activated',
  COST_CENTERS = 'cost_centers',
  EXPENSE_CATEGORIES = 'expense_categories',
  USERS_COUNT_LIMIT = 'users_count_limit',
  FREEMIUM_USERS_COUNT_LIMIT = 'freemium_user_count_limit',
  PURCHASE_ORDERS = 'purchase_orders',
  PURCHASE_ORDERS_ACTIVATED = 'purchase_orders_activated',
  PURCHASE_ORDERS_LEGACY_CREATION = 'purchase_orders_legacy_creation',
  ALLOCATION_PERIOD = 'allocation_period',
  STRONG_CUSTOMER_AUTHENTICATION = 'strong_customer_authentication',
  WIRE_TRANSFER_FOR_INVOICES = 'wire_transfer_for_invoices',
  DASHBOARD = 'dashboard',
  CONTROL_ON_SPENDING_METHODS = 'control_on_spending_methods',
  CONTROL_ON_PURCHASE_ORDER = 'control_on_purchase_order',
  CONTROL_ON_SUBMIT_MY_INVOICE = 'control_on_submit_my_invoice',
  SPANISH_DPR = 'spanish_dpr',
  TMP_SPANISH_DPR_PHASE_2 = 'tmp_spanish_dpr_phase_2',
  TMP_ACCOUNTING_DATE = 'tmp_accounting_date',
  TMP_HIDE_EXPENSE_ACCOUNTS = 'tmp_accounting_integration_hide_expense_accounts',
  SETTINGS_ACCOUNTING = 'settings_accounting',
  SETTINGS_ACCOUNTS_PAYABLE = 'settings_accounts_payable',
  SETTINGS_ACCOUNTING_EXPORTS = 'settings_accounting_exports',
  SETTINGS_COST_CENTERS = 'settings_cost_centers',
  ADVANCED_RULE_BASED_AUTOMATION = 'advanced_rule_based_automation',
  SUBSCRIPTION_RECURRENCE = 'subscription_recurrence',
  MULTI_USE_VIRTUAL_CARDS = 'multi_use_virtual_cards',
  FAILED_TRANSACTIONS = 'failed_transactions',
  PROCUREMENT = 'procurement',
  PROFILE_USER_SECURITY_INFOS = 'profile_user_security_infos',
  TMP_MEMBER_TABLE_ROWS_QUERY = 'tmp_member_table_rows_query',
  BOOKKEEP = 'bookkeep',
  BOOKKEEP_AMORTISATION = 'bookkeep_amortisation',
  BOOKKEEP_PAYABLES = 'bookkeep_payables',
  TMP_BOOKKEEP_PREPARE_TABLEVIEW = 'tmp_bookkeep_prepare_tableview',
  ANALYTICAL_SPLIT = 'analytical_split',
  HAS_OPTED_IN_TO_ANALYTICAL_SPLIT = 'has_opted_in_to_analytical_split',
  // Remove me when project is released
  CAUTION_REMOVE_VAT_CAPABILITY = 'caution_remove_vat_capability',
  API_KEYS_PAGE = 'api_keys_page',
  NATIVE_EXPORTS_DISABLED = 'native_exports_disabled',
  FILE_BASED_EXPORTS_DISABLED = 'file_based_exports_disabled',
  PARTIAL_MAINTENANCE_ENABLED = 'partial_maintenance_enabled',
  PUBLIC_API_DISPLAY_EXPERIMENTAL_SCOPES = 'public_api_display_experimental_scopes',
  TMP_NETSUITE_BETA = 'tmp_native_netsuite_beta',
  MANDATORY_INVOICE_PURCHASE_ORDER = 'mandatory_invoice_purchase_order',
  TMP_GET_AVAILABLE_ACCOUNTING_INTEGRATIONS_USING_REST = 'tmp_get_available_accounting_integrations_using_rest',
  TMP_GET_AVAILABLE_ACCOUNTING_INTEGRATIONS_DIFF_CHECK = 'tmp_get_available_accounting_integrations_diff_check',
  TMP_SFS_MIGRATION_ENABLE_ID_VERIFICATION = 'tmp_sfs_migration_enable_id_verification',
  WIRE_TRANSFER_DELEGATION = 'wt_delegation',
  REPORTING_MANAGERS = 'reporting_managers',
  MILEAGE_UK_COMPANY_VEHICLE = 'mileage_uk_company_vehicle',
  MILEAGE_UK_PASSENGERS = 'mileage_uk_passengers',
  MULTI_ENTITY_CONFIG = 'multi_entity_config',
  TMP_MILEAGE_UK_FUEL_RECEIPT = 'tmp_mileage_uk_fuel_receipt',
  ORGANISATION_REPORTING_PAGE = 'organisation_reporting_page',
  MULTIDIMENSIONAL_APPROVAL_WORKFLOW = 'multidimensional_approval_workflow',
  TMP_EXPENSE_CATEGORIES_BULK_ACTIONS = 'tmp_expense_categories_bulk_actions',
  ADVANCED_APPROVAL_WORKFLOW = 'advanced_approval_workflow',
  SPEND_LIMITS = 'spend_limits',
  ADVANCED_SPEND_LIMITS = 'advanced_spend_limits',
  TMP_ORGANISATION_REPORTING_GROUP = 'tmp_organisation_reporting_group',
  TMP_ORGANISATION_REPORTING_WALLET = 'tmp_organisation_reporting_wallet',
  TMP_ORGANISATION_REPORTING_REQUESTS_TO_APPROVE = 'tmp_organisation_reporting_requests',
  TMP_ORGANISATION_REPORTING_INVOICES_TO_PAY = 'tmp_organisation_reporting_invoices',
  TMP_ORGANISATION_REPORTING_LATE_RECEIPTS = 'tmp_organisation_reporting_receipts',
  TMP_ORGANISATION_REPORTING_PAYABLES_TO_REVIEW = 'tmp_organisation_reporting_payables',
  TMP_CONFIRMATION_OF_PAYEE = 'tmp_confirmation_of_payee',
  TMP_NATIVE_SAGE100_BETA = 'tmp_native_sage100_beta',
  TMP_NATIVE_ACD_BETA = 'tmp_native_acd_beta',
  TMP_NATIVE_ODOO_BETA = 'tmp_native_odoo_beta',
  TMP_NATIVE_EXACT_ONLINE_FR_BETA = 'tmp_native_exact_fr_beta',
  NATIVE_EXACT_BE = 'native_exact_be',
  NATIVE_EXACT_NL = 'native_exact_nl',
  TMP_NATIVE_MICROSOFT_DYNAMICS_BETA = 'tmp_native_microsoft_dynamics_beta',
  NATIVE_SAGE_INTACCT = 'native_sage_intacct',
  NATIVE_DATEV_REWE = 'native_datev_rewe',
  TMP_PUBLIC_API_INTEGRATION_BETA = 'tmp_public_api_integration_beta',
  TMP_MAP_SYNC = 'tmp_map_sync',
  TMP_TWO_WAY_MATCH_WITH_LINE_ITEMS = 'tmp_two_way_match_with_line_items',
  TMP_BUDGETS_REFRESHED = 'tmp_budgets_refreshed',
  DELIVERY_NOTES_FEATURE = 'delivery_notes_feature',
  DELIVERY_NOTES_FEATURE_ACTIVATED = 'delivery_notes_feature_activated',
  THREE_WAY_MATCH = 'three_way_match',
  TMP_ADYEN_MISSING_INFORMATION = 'tmp_adyen_missing_information',
  NETSUITE_CARD_EXCHANGE_RATE = 'netsuite_card_exchange_rate',
  NETSUITE_INVOICE_EXPENSE_CLAIMS_EXCHANGE_RATE = 'netsuite_invoice_expense_claims_exchange_rate',
  TMP_PURCHASE_ORDER_DETAILS_OCR = 'tmp_purchase_order_details_ocr',
  SEND_PURCHASE_ORDER_PDF_EMAIL_TO_SUPPLIER = 'send_purchase_order_pdf_email_to_supplier',
  TMP_SEND_AUTOMATIC_PO_PDF = 'tmp_send_automatic_po_pdf',
  TMP_ANALYTICAL_SPLITS = 'tmp_analytical_splits',
  FRAUD_DETECTION = 'fraud_detection',
  TRAVEL_BUDGET_REQUEST = 'travel_budget_request',
  TRAVEL_STAYS_BOOKING = 'travel_stays_booking',
  TRAVEL_BOOKING_REQUEST = 'travel_booking_request',
  TRAVEL_BUDGET_REQUEST_MULTI_USE_CARDS = 'travel_budget_request_multi_use_cards',
  TMP_PURCHASE_ORDER_EDIT = 'tmp_purchase_order_edit',
  TMP_SCHEDULE_UK_TRANSFERS = 'tmp_schedule_uk_transfers',
  TMP_SHOW_ANNUAL_TURNOVER_STEP = 'tmp_show_annual_turnover_step',
  SHOW_SECURITY_TAB_IN_USER_EDITION = 'show_security_tab_in_user_edition',
  TOTP = 'totp',
  REQUEST_CARD_LIMITS_INCREASE = 'request_card_limits_increase',
  INVOICE_TO_CARD = 'invoice_to_card',
  TMP_VERIFICATION_OF_PAYEE_EEA = 'tmp_verification_of_payee_eea',
  SINGLE_USE_CARDS_PAGE = 'single_use_cards_page',
  TMP_INSTANT_PAYMENT = 'tmp_instant_payment',
  TMP_E_INVOICE_PAYMENT_MATCHING = 'tmp_e_invoice_payment_matching',
  CARD_HOLDER_FAKE_NAME_DETECTION = 'card_holder_fake_name_detection',
  TMP_REQUEST_FORM_PREDICTION = 'tmp_request_form_prediction',
  TMP_REQUEST_FORM_PREDICTION_BACKEND_SHADOW = 'tmp_request_form_prediction_backend_shadow',
  HAS_MULTI_USE_CARD_END_DATE_CHANGE = 'has_multi_use_card_end_date_change',
  HAS_MULTI_USE_CARD_TOP_UP = 'has_multi_use_card_top_up',
}

export default FEATURES;
